import React, { useEffect, useState } from "react";

import { FaArrowRight } from "react-icons/fa";
import { FaArrowLeft } from "react-icons/fa";
import HomeSliderTwo from "../../HomeSliderTwo/HomeSliderTwo";
import HomeSliderOne from "../../HomeSliderOne/HomeSliderOne";
import "./ServiceSlider.css";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import EventList from "../../../component/EventItem/EventItems";
function ServiceSlider() {
  const words = [
    "Graduation",
    "Farewell",
    "Office-Event",
    "Party-Wear",
    "Ethnic-Day",
    "PreWedding",

    "Weddings",
  ];

  const fontFamilies = [
    "Graduate",
    "Roboto",
    "Merriweather",
    "Pacifico",
    "Indie Flower",
    "Lobster",
    "Monospace",
  ];


  const fontFamiliessecond = [
    "Graduate",
    "Roboto",
    "Merriweather",
    "Pacifico",
    "Indie Flower",
    "Lobster",
    "Monospace",
  ];

  const [currentWordIndex, setCurrentWordIndex] = useState(0);


  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentWordIndex((prevIndex) => (prevIndex + 1) % words.length);
    }, 1500); // Change every 3 seconds

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);


  const words1 = [
    "Jodhpuri-Suits",
    "Suits & Tuxedos",
    "Blazers & Suits",
    "Ethnic & Jackets",
    "Kurta & Pyjama",
    "Indowestern",
    "Sherwani & Suits"
  ];

  const [currentWordIndex1, setCurrentWordIndex1] = useState(0);

  useEffect(() => {
    const interval1 = setInterval(() => {
      setCurrentWordIndex1((prevIndex) => (prevIndex + 1) % words1.length);
    }, 1500); // Change every 3 seconds

    return () => clearInterval(interval1); // Cleanup on unmount
  }, []);

  const navigate = useNavigate();
  const events = [
    { image: "images/collections/party1.jpg", eventName: "Jodhpuri Suits" },
    { image: "images/collections/wedding1.jpg", eventName: "Suits & Tuxedos" },
    { image: "images/collections/photoshot1.jpg", eventName: "Blazers" },
    { image: "images/collections/office1.jpg", eventName: "Ethnic Jackets & Kurta Pyjama" },
    { image: "images/collections/graduation1.jpg", eventName: "Indowestern & Sherwani" },
    { image: "images/collections/attend1.jpg", eventName: "Ethnic Jackets & Kurta Pyjama" }, // Duplicate style if needed
  ];
  const handleEventClick = (eventName) => {
    navigate("/products", { state: { selectedStyle: eventName } }); // Pass selected style to products page
  };
  return (
    <div>

      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginLeft: "20px", marginRight: "20px", marginTop: "1%" }}>
        {/* <div className="leftdivider" style={{ height: "3px", width: "40%", background: "black", marginRight: "10px" }}></div> */}
        <h5 className="heading tenhead" style={{fontFamily:"Scheherazade New",color:"#182C52",fontWeight:"800"}}>TRENDING NOW</h5>
        {/* <div className="leftdivider" style={{ height: "3px", width: "40%", background: "black", marginLeft: "10px" }}></div> */}
      </div>


      <HomeSliderOne />

      <section className=" pt_0">
        <div className="container">
          <div className="tf-grid-layout md-col-2 tf-img-with-text style-2" >
            <div class="">
              <div class="collection-item-v4 style-2 style-3 hover-img m-3">
                <div class="collection-inner ">
                  <div className="tf-image-wrap wow fadeInUp" data-wow-delay="0s">
                    <a href="shop-collection-sub.html" class="collection-image img-style radius-10 o-hidden">
                      <img class="lazyload" data-src="images/collections/hc1.jpg" src="images/collections/hc1.jpg" alt="collection-img" />
                    </a>
                  </div>
                  <div class="collection-content text-left wow fadeInUp" data-wow-delay="0s">
                    <p class="subheading text-white">NEW COLLECTION</p>
                    <h5 class="heading text-white">Find your <br />perfect stroller</h5>
                    <p class="subtext text-white">New timeless colors, here to stay</p>
                    <a href="/products" class="tf-btn style-2 btn-fill radius-3 animate-hover-btn"><span>SHOP NOW</span></a>
                  </div>
                </div>
              </div>
            </div>
            <div >
              <div class="collection-item-v4 style-2 style-3 hover-img m-3">
                <div class="collection-inner">
                  <div class="tf-image-wrap wow fadeInUp" data-wow-delay="0s">
                    <a href="shop-collection-sub.html" class="collection-image img-style radius-10 o-hidden">
                      <img class="lazyload" data-src="images/collections/DSC04383.jpg" src="images/collections/DSC04383.jpg" alt="collection-img" />
                    </a>
                  </div>
                  <div class="collection-content text-left wow fadeInUp" data-wow-delay="0s">
                    <p class="subheading text-white">NEW COLLECTION</p>
                    <h5 class="heading text-white">Find your <br />perfect stroller</h5>
                    <p class="subtext text-white">New timeless colors, here to stay</p>
                    <a href="/products" class="tf-btn style-2 btn-fill radius-3 animate-hover-btn"><span>SHOP NOW</span></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div

        style={{
          display: "flex",
          minWidth: "100%",
          alignItems: "center",
          justifyContent: "center",
          marginTop: "1%",
          marginBottom: "1%",
        }}
      >
        {/* Left Divider */}
        <div
          className="leftdivider"
        ></div>

        {/* Title Section */}
        <div
          style={{
            minWidth: "30%",
            padding: "0 20px", // Space between the text and the dividers
            whiteSpace: "nowrap", // Prevent text wrapping

          }}
        >
          <h5
            className="heading topheadname"

          >
            <span style={{fontFamily:"Mate SC",fontWeight:"800"}}>
              Rent for Every</span><span style={{height:"40px",border:"2px solid #171717",padding:"3px",fontFamily: fontFamilies[currentWordIndex]}} >{" "}{words[currentWordIndex]}</span>

          </h5>
        </div>

        {/* Right Divider */}
        <div className="leftdivider"></div>
      </div>



      <EventList />

      <section>
        <div className="container-full flat-spacing-8">
          <div className="bg_green-1 radius-100 radius-10 rounded-bottom-0 " style={{ paddingBottom: '80px' }}>
            <div className="flat-title">
              {/* <span className="title fw-6">Why choose us?</span> */}
            </div>
            <div className="container flat-iconbox-v3">
              <div className="wrap-iconbox">
                <div className="icon-box" style={{ backgroundColor: "transparent", marginTop: "20px" }}>
                  <div className="tf-icon-box text-center">
                    <div className="icon">
                      <img src="images/collections/rent.png" alt="Rent" style={{filter:"invert(1)"}}/>
                    </div>
                    <div className="content">
                      <h4 className="heading" style={{fontFamily:"Bona Nova SC",color:"white"}}>Rent</h4>
                      <p style={{ fontFamily: "Spectral", fontSize: "18px",color:"white" }} className="paragraph_offer">
                        you can enjoy high-quality, affordable <br />
                        just stepping up your style game without committing to a single piece.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="icon-box" style={{ backgroundColor: "transparent", marginTop: "20px" }}>
                  <div className="tf-icon-box text-center">
                    <div className="icon">
                      <img src="images/collections/clothing.png" alt="Wear" style={{filter:"invert(1)"}}/>
                    </div>
                    <div className="content">
                      <h4 className="heading" style={{fontFamily:"Bona Nova SC",color:"white"}}>Wear</h4>
                      <p style={{ fontFamily: "Spectral", fontSize: "18px",color:"white" }} className="paragraph_offer">
                        With top-notch brands and styles <br />
                        boosting your confidence without breaking the bank. Try new looks and find the perfect fit.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="icon-box" style={{ backgroundColor: "transparent", marginTop: "20px" }}>
                  <div className="tf-icon-box text-center">
                    <div className="icon" >
                      <img src="images/collections/investment.png" alt="Save" style={{filter:"invert(1)"}}/>
                    </div>
                    <div className="content">
                      <h4 className="heading" style={{fontFamily:"Bona Nova SC",color:"white"}}>Save</h4>
                      <p style={{ fontFamily: "Spectral", fontSize: "18px",color:"white" }} className="paragraph_offer">
                        saves you the trouble of overspending on items you only wear a few times <br />
                        contributing to a more sustainable future.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>



      <section className=" pt_0">
        <div className="container">
          <div className="tf-grid-layout md-col-2 tf-img-with-text style-2">
            <div className="tf-image-wrap wow fadeInUp" data-wow-delay="0s">
              <img className="lazyload" data-src="images/collections/feelyourbest.png" src="images/collections/feelyourbest.png" alt="collection-img" />
            </div>
            <div className="tf-content-wrap text-center w-100 wow fadeInUp" data-wow-delay="0s">
              <span className="sub-heading text-uppercase fw-7">impression with effortless sophistication.</span>
              <h1 className="heading">Feel Your Best</h1>
              <p className="description" style={{ fontFamily: 'Raleway, serif' }}>Access premium blazers without commitment. <br className="d-none d-xl-block" /> Stylish comfort tailored for you.</p>
              <Link to='/products' className="tf-btn style-2 btn-fill radius-3 animate-hover-btn">SHOP COLLECTION</Link>
            </div>
          </div>
        </div>
      </section>



      <div

        style={{
          display: "flex",
          minWidth: "100%",
          alignItems: "center",
          justifyContent: "center",
          marginTop: "1%",
          marginBottom: "1%",
        }}
      >
        {/* Left Divider */}
        <div
          className="leftdivider"
        ></div>

        {/* Title Section */}
        <div
          style={{
            minWidth: "35%",
            padding: "0 20px", // Space between the text and the dividers
            whiteSpace: "nowrap", // Prevent text wrapping
          }}
        >
          <h5
            className="heading topheadname"

          >
            <span style={{fontFamily:"Mate SC",fontWeight:"800"}}>
              Rent For Categories</span><span style={{height:"40px",border:"2px solid #171717",padding:"3px",fontFamily: fontFamiliessecond[currentWordIndex]}}>{" "}{words1[currentWordIndex1]}</span>

          </h5>
        </div>

        {/* Right Divider */}
        <div className="leftdivider"></div>
      </div>
      <HomeSliderTwo />



      <section className="flat-spacing-8 pb_0">
        <div className="container">
          <div className="tf-banner-collection">
            <img className="lazyload" data-src="images/collections/banner6.jpg" src="images/collections/banner6.jpg" alt="img-banner" loading="lazy" class="banner_mobileview" />
            {/* <img className="lazyload" data-src="images/collections/banner2.png" src="images/collections/banner2.png" alt="img-banner" loading="lazy" class="banner_desktopview"/> */}
            <div className="box-content" >
              <div className="container wow fadeInUp" data-wow-delay="0s">
                <div className="sub fw-7 " style={{color:"white"}}>Step Into Timeless Elegance</div>
                <h2 className="heading fw-6 " style={{color:"white"}}>Stylish Comfort Tailored For You.</h2>
                <p className="" style={{ fontFamily: 'Raleway, serif',color:"white" }}>Elevate your look, embody elegance.</p>
                <Link to='/products' className="tf-btn style-2 btn-fill radius-3 animate-hover-btn">SHOP COLLECTION</Link>

                {/* <a href="shop-default.html" className="rounded-full tf-btn style-3 fw-6 btn-light-icon animate-hover-btn"><span style={{color:"black"}}>SHOP COLLECTION</span></a> */}
              </div>
            </div>
          </div>
        </div>
      </section>





    </div>
  );
}

export default ServiceSlider;
